import {
  API_CALL
} from 'apa/actions/types'
import {
  apiStart,
  apiEnd,
  apiError,
  apiSuccess,
  parseError,
  accessDenied, sendMessage
} from 'apa/actions'

function encodeQueryData (data) {
  return Object.keys(data).filter(key => typeof data[key] !== 'undefined').map(
    key => [key, data[key]].map(encodeURIComponent).join('=')
  ).join('&')
}

function getURL (url, parameters) {
  return `${url}?${encodeQueryData(parameters)}`
}


export const apiMiddleware = store => next => action => {
  next(action)
  if (action.type !== API_CALL) return

  const {
    getState,
    dispatch
  } = store

  const {
    url,
    method,
    data,
    onSuccess,
    onFailure,
    label,
    needsToken
  } = action.payload;
  const state = getState()
  const accessToken = state.apa.token
  const headers = {}
  
  if (needsToken) {
    headers['Authorization'] = `Token ${accessToken}`;
  }

  let body;
  let correctUrl;
  const hasSideEffects = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);
  const isLogin = url.endsWith('/api/auth/login/')

  if (hasSideEffects) {
    if(data instanceof FormData) {
      body = data
    } else {
      body = JSON.stringify(data)
      headers['Content-Type'] = 'application/json';
    }
    
    correctUrl = url;
  } else {
    if(data) {
      correctUrl = getURL(url, data);
    } else {
      correctUrl = url;
    }
    body = null
  }

  if (label) {
    dispatch(apiStart(label));
  }

  fetch(
    correctUrl, { method, headers, body }
  ).then(
    response => {
        if(response.status === 204 || response.text === '204') {
          apiSuccess()
          dispatch(onSuccess())
          return;
        }
        response.json().then(
          body => {
            if (response.status < 400) {
              if(hasSideEffects && !isLogin) {
                dispatch(sendMessage({text: 'Änderungen gespeichert.', color: 'success'}))
              }
              apiSuccess(body)
              dispatch(onSuccess(body))
            } else if (response.status === 400) {
              dispatch(onFailure(body))
            } else if (response.status === 401) {
              dispatch(sendMessage({text: 'Sitzung abgelaufen.', color: 'warning'}))
              dispatch(accessDenied(window.location.pathname))
              dispatch(onFailure(body))
            } else {
              dispatch(apiError(body))
              dispatch(onFailure(body))
            }
          }
        ).catch(
          error => {
            dispatch(parseError(error))
            dispatch(onFailure(error))
          }
        )
    }
  ).catch(
    error => {
      dispatch(apiError(error))
      dispatch(onFailure(error))
    }
  ).finally(
    () => dispatch(apiEnd(label))
  )
}
